import headers from './headers'

export default function(fetch) {
  return function(projectId) {
    const h = headers()

    return fetch(`${process.env.REACT_APP_API_URL}/projects/${projectId}`, {
      headers: h,
      method: 'GET',
    })
      .then(res => {
        if (res.status !== 200) {
          throw new Error('Project not found')
        }

        return res
      })
      .then(res => res.json())
      .then(res => ({ id: res.id, ...res.metadata }))
  }
}



// WEBPACK FOOTER //
// ./src/repositories/getProject.js